import { observer } from 'mobx-react'

import type ArgumentForm from 'modules/reports/components/Editor/Field/Options/Types/Filtering/ArgumentForm'
import type { OperatorForm } from 'modules/reports/components/Editor/Field/Options/Types/Filtering/forms'
import type { FieldType } from 'modules/reports/components/Editor/Field/types'
import { conditionType } from 'modules/reports/lib/fieldHelper'

import CheckboxConditions from './Types/Checkbox'
import DateConditions from './Types/Date'
import DocumentCategorySelector from './Types/DocumentCategorySelector'
import EnumsConditions from './Types/Enums'
import LeaveTypeSelector from './Types/LeaveTypeSelector'
// To be deprecated individually in favor of Enums
import NationalitySelector from './Types/NationalitySelector'
import OfficeSelector from './Types/OfficeSelector'
import PhaseSelector from './Types/PhaseSelector'
import TeamSelector from './Types/TeamSelector'
// Generics
import TextConditions from './Types/Text'

interface Props {
  fieldType: FieldType
  variables: any
  operatorForm: OperatorForm
  forms: ArgumentForm[]
  onToggleNestedPopover: (open: boolean) => void
}

// Entry point for super generics
// - text
// - date
// - null
// - enums
const COMPONENTS = {
  text: TextConditions,
  date: DateConditions,
  checkbox: CheckboxConditions,
  boolean: CheckboxConditions,
  enum: EnumsConditions,
}

const ESPECIAL_FIELDS: Record<string, any> = {
  'employee.nationality': NationalitySelector,
  'employee.office': OfficeSelector,
  'employee.team': TeamSelector,
  'team.name': TeamSelector,
  'document.type': DocumentCategorySelector,
  'leave.leave_type_name': LeaveTypeSelector,
  'ats_job_posting.team': TeamSelector,
  'ats_job_posting.office': OfficeSelector,
  'ats_application.phase': PhaseSelector,
}

const ConditionPicker = ({
  fieldType,
  variables,
  operatorForm,
  forms,
  onToggleNestedPopover,
}: Props) => {
  const getComponent = () => {
    const { field } = fieldType

    if (!field) return null

    const path = field.attributes.path

    if (path && ESPECIAL_FIELDS[path]) return ESPECIAL_FIELDS[path]

    return COMPONENTS[conditionType(field)]
  }

  const Component = getComponent()

  if (!Component) return null

  return (
    <Component
      forms={forms}
      fieldType={fieldType}
      variables={variables}
      operatorForm={operatorForm}
      onToggleNestedPopover={onToggleNestedPopover}
    />
  )
}

export default observer(ConditionPicker)
